module.exports = __webpack_public_path__ + "static/marketingautomation-452ef5c8f50a6e838d2f03a59608c336.jpeg";